export default {
    getUserInfo: state => state.user,
    isPresent: state => state.isPresent,
    isLoggedIn: state => state.status.loggedIn,
    name: state => state.user.name.split(" ")[0]
}